import React, {useEffect, useState} from "react";

//https://api.countapi.xyz/update/rlucioporto/webpage/?amount=1

const VisitCounter = () =>{
    const [visits, setVisits] = useState(0)
    const [error, setError] = useState(false)

    useEffect(()=>{
        // Try to get visit count from API
        fetch('https://api.countapi.xyz/info/rlucioporto/webpage')
        .then(res => {
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then(res => {
            if (res.value !== undefined) {
                setVisits(res.value);
                // Store in localStorage as backup
                localStorage.setItem('visitCount', res.value.toString());
            } else {
                throw new Error('Invalid response format');
            }
        })
        .catch(error => {
            console.error('Error fetching visit count:', error);
            setError(true);
            // Fallback to localStorage if available
            const storedCount = localStorage.getItem('visitCount');
            if (storedCount) {
                setVisits(parseInt(storedCount, 10));
            }
        });
    }, [])    
    return(
      <div style={{background: '#192a56'}} className="min-vh-100 d-flex align-items-center justify-content-center">
         <div className="text-light d-flex gap-4 flex-column">
            <div className="d-flex gap-2"><p className="fs-2">This page was viewed</p></div>
            <div className="d-flex align-items-center justify-content-center"> 
                <p id='count' className="fs-1"> {visits || 0} </p>
                {error && <span className="ms-2 text-warning" title="Using cached value">⚠</span>}
            </div>
            <div className="d-flex align-items-center justify-content-center"> <p className="fs-2"> times</p></div>
         </div> 
      </div>
    )
  }

export default VisitCounter;

